import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { Routes, RouterModule }  from '@angular/router';
import { FormsModule }    from '@angular/forms';
import { HttpModule  }  from '@angular/http';
import { LoginComponent } from './login.component';
import { ForgetPasswordComponent } from './forget-password.component';
import { ConfirmPasswordComponent } from './confirm-password.component';
import { ResetPasswordReq } from './resetPasswordreq.page';
import { PagesPage404 } from './page-404.page';
import { AuthenticationService } from './AuthService/auth.service';
import { ForgetService } from './AuthService/forget.service';
import { Configuration } from '../Configuration';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    LoginComponent,
   ForgetPasswordComponent,
    ConfirmPasswordComponent,
    ResetPasswordReq,
    PagesPage404 
  ],
    providers: [
    AuthenticationService,
   ForgetService, Configuration
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts